import { render, staticRenderFns } from "./PageElementSwiper.vue?vue&type=template&id=b3eef010&scoped=true"
import script from "./PageElementSwiper.vue?vue&type=script&lang=js"
export * from "./PageElementSwiper.vue?vue&type=script&lang=js"
import style0 from "./PageElementSwiper.vue?vue&type=style&index=0&id=b3eef010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3eef010",
  null
  
)

export default component.exports